// routes for Warehouse
import { AppRouteProps } from '~/routes';
import Index from './pages/Index';
import Create from './pages/Create';
import Edit from './pages/Edit';

export default function ResourcesWarehousesRoutes(): readonly AppRouteProps[] {
  const routes: readonly AppRouteProps[] = [
    {
      path: '/warehouse',
      component: Index,
      isProtected: true,
      permissions: ['warehouse_index'],
    },
    {
      path: '/warehouse/create',
      component: Create,
      isProtected: true,
      permissions: ['warehouse_create'],
    },
    {
      path: '/warehouse/edit/:id',
      component: Edit,
      isProtected: true,
      permissions: ['warehouse_edit'],
    },
  ];

  return routes;
}
